/*
 * @Date: 2018-08-07 11:26:08
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2018-11-12 11:12:52
 * @Description: 全局请求权限列表model
 * @Company: Copyright (c) 2018. supOS
 */
import { setConfigInfo, getConfigInfo } from '../services/api';
import defaultBg from '../assets/img/bg_login_pure.jpg';
import defaultLogo from '../assets/img/icons/logo_index.svg';
import defaultTagline from '../assets/img/icons/text_login.svg';
// import defaultLeftLogo from '../assets/img/icons/logo.svg';

export default {
  namespace: 'global',

  state: {
    collapsed: false,
    hasSystemManage: false,
    pageTitle: '',
    backendVersion: undefined,
    emailServer: {
      smtp_server: '',
      smtp_server_port: '',
      smtp: '',
      smtp_account_user: '',
      smtp_account_password: ''
    },
    right: '',
    tip: '',
    loadings: false,
    loginImgs: {
      bg: '',
      logo: '',
      tagline: '',
      leftLogo: '',
      loginTitle: ''
    },
    showTitle: true,
    deviceClickHandle: null
  },

  effects: {
    * setLoginImgs({ payload, callback }, { call, put }) {
      const data = JSON.parse(payload.configValue);
      const response = yield call(setConfigInfo, payload);
      yield put({
        type: 'setLoginImgsList',
        payload: response,
        data
      });
      if (callback) callback(response);
    },
    * getLoginImgs({ payload, callback }, { call, put }) {
      const response = yield call(getConfigInfo, payload);
      yield put({
        type: 'getLoginImgsList',
        payload: response
      });
      if (callback) callback(response);
    },
    * setGlobalFrentendFn({ payload, callback }, { call, put }) {
      const data = JSON.parse(payload.configValue);
      const response = yield call(setConfigInfo, payload);
      yield put({
        type: 'setGlobalFn',
        payload: response,
        data
      });
      if (callback) callback(response);
    },
    * getGlobalFrentendFn({ payload, callback }, { call, put }) {
      const response = yield call(getConfigInfo, payload);
      yield put({
        type: 'getGlobalFn',
        payload: response
      });
      if (callback) callback(response);
    },
    * setEmailConfig({ payload, callback }, { call, put }) {
      const response = yield call(setConfigInfo, payload);
      yield put({
        type: 'updateStatus',
        payload: {
          response,
          emailServer: JSON.parse(payload.configValue)
        }
      });
      if (callback) callback(response);
    },
    * getEmailConfig({ payload, callback }, { call, put }) {
      const response = yield call(getConfigInfo, payload);
      yield put({
        type: 'getEmailServer',
        payload: response
      });
      if (callback) callback(response);
    },
    * topLoadingShow({ payload }, { put }) {
      yield put({
        type: 'loadingShow',
        payload
      });
    },
    * topLoadingHide({ payload }, { put }) {
      yield put({
        type: 'loadingHide',
        payload
      });
    }
  },

  reducers: {
    titleVisible(state, { payload }) {
      return {
        ...state,
        showTitle: payload.showTitle
      };
    },
    loadingShow(state, { payload }) {
      return {
        ...state,
        loadings: payload.loading,
        tip: payload.tip
      };
    },
    loadingHide(state, { payload }) {
      return {
        ...state,
        loadings: payload.loading
      };
    },
    changeLayoutCollapsed(state, { payload }) {
      return {
        ...state,
        collapsed: payload
      };
    },
    updatePageTitle(state, { payload }) {
      return {
        ...state,
        pageTitle: payload
      };
    },
    setLoginImgsList(state, { data }) {
      const { right, bg, logo, tagline, leftLogo, loginTitle } = data;
      return {
        ...state,
        right,
        loginImgs: {
          bg: bg || defaultBg,
          logo: logo || defaultLogo,
          tagline: tagline || defaultTagline,
          leftLogo: leftLogo || '',
          loginTitle
        }
      };
    },
    getLoginImgsList(state, { payload }) {
      const configValue = payload && payload.configValue ? JSON.parse(payload.configValue) : '';
      return {
        ...state,
        right: configValue.right,
        loginImgs: {
          bg: configValue && configValue.bg ? configValue.bg : defaultBg,
          logo: configValue && configValue.logo ? configValue.logo : defaultLogo,
          tagline: configValue && configValue.tagline ? configValue.tagline : defaultTagline,
          leftLogo: configValue && configValue.leftLogo ? configValue.leftLogo : '',
          loginTitle: configValue && configValue.loginTitle ? configValue.loginTitle : ''
        }
      };
    },
    getGlobalFn(state, { payload }) {
      const configValue = payload && payload.configValue ? JSON.parse(payload.configValue) : '';
      return {
        ...state,
        deviceClickHandle: configValue.deviceClickHandle
      };
    },
    setGlobalFn(state, { data }) {
      const { deviceClickHandle } = data;
      return {
        ...state,
        deviceClickHandle
      };
    },
    getEmailServer(state, { payload }) {
      return {
        ...state,
        emailServer: payload && payload.configValue ? JSON.parse(payload.configValue) : state.emailServer
      };
    },
    updateStatus(state, { payload }) {
      return {
        ...state,
        ...payload
      };
    }
  },

  subscriptions: {
    setup({ history }) {
      // Subscribe history(url) change, trigger `load` action if pathname is `/`
      return history.listen(({ pathname, search }) => {
        if (typeof window.ga !== 'undefined') {
          window.ga('send', 'pageview', pathname + search);
        }
      });
    }
  }
};
